import {Game2048} from "./Game2048";

export function Game19() {
    return <Game2048 isRules={false} />
}